export default __webpack_public_path__ + "static/media/geology-mercury.aa6732c3.png";